import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupSuccessFormComponent } from '../../ui/signup-success-form/signup-success-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'equine-ui-nx-signup-success',
  standalone: true,
  imports: [CommonModule, SignupSuccessFormComponent],
  templateUrl: './signup-success.component.html',
  styleUrl: './signup-success.component.css',
})
export class SignupSuccessComponent implements OnInit, OnDestroy{
  unsubscribe$ = new Subject<void>();
  appName!: string;
  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}
  
  ngOnInit(): void {
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName;
    })
  }
  navigateToSignupVerify() {
    this.router.navigate(['account','verify']);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
